import { Component } from '@angular/core';
import { FileInputComponentDef } from '@df/ui/form/file-input.component.def';

export interface IFileInputEvent {
    file?: File;
    error?: Error;
}

/**
 * @deprecated use local
 */
@Component({
    selector: 'file-input',
    templateUrl: './file-input.html',
    standalone: true
})
export class FileInputComponent extends FileInputComponentDef {}
